import { Injectable } from "@angular/core";
import { SubmissionsFacade } from "../../../../domain/+state/submissions.facade";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { SubmissionDetailsFacade } from "../../submission-details.facade";
import { SubmissionDetailsBaseComponentData } from "../../submission-details.model";
import { ContractDetailsComponentData } from "./contract-details.model";
import { getContractDetailsAppBarActions, getContractDetailsHeaderData, loanCreatedDialogData } from "./contract-details.data";
import { SimpleDialogComponent, SimpleDialogData } from "common";
import { MatDialog } from "@angular/material/dialog";
import { OfferDetailsSectionAdapter } from "../../shared/modules/offer-details-section/offer-details-section.data";

@Injectable()
export class ContractDetailsFacade {
  constructor(
    private readonly detailsFacade: SubmissionDetailsFacade,
    private readonly submissionsFacade: SubmissionsFacade,
    private readonly offerDetailsSectionAdapter: OfferDetailsSectionAdapter,
    private readonly dialog: MatDialog,
  ) { }

  getComponentData$(applicationId: number): Observable<ContractDetailsComponentData> {
    return this.detailsFacade.getComponentBaseData$(applicationId)
      .pipe(map((data: SubmissionDetailsBaseComponentData) => {
        const headerData = getContractDetailsHeaderData(data.application.brokerStatus);
        const offerDetailsData = this.offerDetailsSectionAdapter.adaptOfferDetailsSectionData(data.application);
        const appBarActions = getContractDetailsAppBarActions(data.application.brokerStatus);
        return {
          ...data,
          headerData,
          offerDetailsData,
          appBarActions
        }
      }));
  }


  sendCheckout(appId: number) {
    return this.submissionsFacade.sendCheckout(appId).pipe(switchMap(() => this.openConfirmationDialog()));
  }

  resendCheckout(appId: number) {
    return this.submissionsFacade.resendCheckout(appId).pipe(switchMap(() => this.openConfirmationDialog()));
  }

  private openConfirmationDialog() {
    const dialogData: SimpleDialogData = loanCreatedDialogData;
    return SimpleDialogComponent.show(this.dialog, dialogData)
  }
}
